
import AppRouter from "./router";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./index.css";
import "./App.css";
import { useTranslation } from "react-i18next";

const theme = createTheme({
  palette: {
    primary: {
      main: "#EFB699",
      light: "#E5A39C",
      dark: "#BFA2CA",
      contrastText: "#3F4E8C",
    },
    secondary: {
      main: "#7479AE",
      light: "#FFF1E6",
      dark: "#3F4E8C",
      contrastText: "#fff",
      100: "#FFF1E6",
      200: "#F7E4DA",
      300: "#D4CAEB",
      400: "#7479AE",
      500: "#3F4E8C",
      600: "#714CC1",
    },
    background: {
      default: "#FFF1E6",
      paper: "#FFF1E6",
    },
  },
  typography: {
    fontFamily: ["'IBM Plex Sans Thai'", "'Poppins'", "sans-serif"].join(","),
    allVariants: {
      fontFamily: ["'IBM Plex Sans Thai'", "'Poppins'", "sans-serif"].join(","),
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

function App() {
  const { i18n } = useTranslation();
  const language = i18n.language || "en";
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CssBaseline />
        <GlobalStyles
          styles={{
            ".MuiAccordion-root::before": {
              backgroundColor: "transparent !important",
            },
            ".MuiButton-root": {
              boxShadow: "none !important",
              borderRadius: "10px !important",
              display: "flex !important",
              alignItems: "center !important",
              justifyContent: "center !important",
              paddingTop: language === "th" ? "5px !important" : "3px !important",
              paddingBottom: language === "th" ? "1px !important" : "3px !important",
            }
          }}
        />
        <AppRouter />
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
